import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const LANGS = [
  { code: 'ru', label: 'RU', name: 'Русский' },
  { code: 'ky', label: 'KY', name: 'Кыргызча' },
  { code: 'en', label: 'EN', name: 'English' },
]

const LangSwitcher = () => {
  const { i18n } = useTranslation()
  const current = (i18n.language || localStorage.getItem('lang') || 'ru').slice(0, 2)

  // Keep <html lang> in sync with the active language for screen readers / SEO.
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = current
    }
  }, [current])

  const change = (code) => {
    if (code === current) return
    try {
      localStorage.setItem('lang', code)
    } catch (_) {
      // localStorage may be unavailable (private mode, SSR) — fall through to changeLanguage.
    }
    if (i18n && typeof i18n.changeLanguage === 'function') {
      i18n.changeLanguage(code)
    }
    if (typeof document !== 'undefined') {
      document.documentElement.lang = code
    }
  }

  const wrap = {
    display: 'inline-flex',
    gap: '2px',
    padding: '3px',
    borderRadius: '8px',
    background: 'var(--color-surface)',
    // border: '1px solid var(--color-border)',
  }

  const btn = (active) => ({
    padding: '4px 10px',
    fontSize: '12px',
    fontWeight: 600,
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    background: active ? 'var(--color-accent)' : 'transparent',
    color: active ? '#FFFFFF' : 'var(--color-text)',
    transition: 'background 0.15s ease, color 0.15s ease',
  })

  return (
    <div style={wrap} role="group" aria-label="Language switcher">
      {LANGS.map((l) => {
        const isActive = current === l.code
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => change(l.code)}
            style={btn(isActive)}
            aria-label={`Switch language to ${l.name}`}
            aria-pressed={isActive}
            lang={l.code}
            title={l.name}
          >
            {l.label}
          </button>
        )
      })}
    </div>
  )
}

export default LangSwitcher
